import { useContext, useEffect, useRef, useMemo } from "react";
import { context } from "../../context/context";
import { auth } from "../../context/auth";
import { CurrentTime } from "../current";
import { collection } from "../../context/collect";

export default function useNewInvoice() {

    const { invoiceId, invoiceNum, cart, edit, total, setTotal, setDiscount2, discount2 } = useContext(context);
    const { user, ActivEmp } = useContext(auth);
    const { client } = useContext(collection);

    // ✅ يتحدد مرة واحدة بس
    const createdAtRef = useRef(CurrentTime());

    // ✅ حساب الإجمالي والخصم
    useEffect(() => {
        const sum = Array.isArray(cart)
            ? cart.reduce((acc, item) => acc + Number(item.amount || 0), 0)
            : 0;

        const sumDiscount = Array.isArray(cart)
            ? cart.reduce((acc, item) =>
                acc + Number(item.discount?.discountValue || 0) * (item.quantity || 0)
            , 0)
            : 0;

        if (client?.mode === "delivery") {
            setTotal(sum + Number(client?.payment || 0));
        } else {
            setTotal(sum);
        }

        setDiscount2(sumDiscount);

    }, [cart, edit, client?.payment, client?.mode]);

    const invoice = useMemo(() => {

        if (!user || !Array.isArray(cart)) return {};

        return {
            id: invoiceId,
            meta: {
                idowner: user?.data?.[0]?.id || "",
                idEmp: `${ActivEmp?.name || ""} #${ActivEmp?.code || ""}`,
                createdAt: createdAtRef.current
            },
            data: structuredClone(cart),
            currency: user?.data?.[0]?.currency,
            end_day: 'f',
            order_number: invoiceNum,

            method: "",
            status: "",

            total: total,
            discount: discount2,

            client_data: client,

            delivery: {
                deliveryID: "",
                exit: "",
                isCollect: false
            },

            returned: false,

            async: {
                status: "f",
                reason: "new"
            },
        };

    }, [
        user,
        ActivEmp,
        cart,
        invoiceNum,
        client,
        total,
        discount2,
        invoiceId,
    ]);

    return invoice;
}